import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelopeOpen,
  faLightbulb,
  faChartLine,
  faOtter,
  faDog,
  faFileArchive,
  faCogs,
  faUser,
  faArrowDown,
  faArrowUp,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import logo from './../images/logo.png';
import { AuthContext } from './../context/AuthContext';

const navItems = [
  {
    label: 'Company',
    path: 'company',
    icon: faChartLine,
    allowedRoles: ['user', 'admin'],
    subMenuItems: [
      {
        label: 'List',
        path: 'company',
        allowedRoles: ['user', 'admin'],
      },
      {
        label: 'Company Edit',
        path: 'company-edit',
        allowedRoles: ['user', 'admin'],
      },
    ],
  },
  {
    label: 'Dashboard',
    path: 'dash',
    icon: faLightbulb,
    allowedRoles: ['user', 'admin'],
  },
  {
    label: 'Archive',
    path: 'archive',
    icon: faFileArchive,
    allowedRoles: ['user', 'admin'],
  },
  {
    label: 'Retrieve',
    path: 'documents',
    icon: faOtter,
    allowedRoles: ['admin'],
  },
  {
    label: 'Send Batch',
    path: 'send',
    icon: faEnvelopeOpen,
    allowedRoles: ['admin'],
  },
  {
    label: 'Omit',
    path: 'omit',
    icon: faEnvelopeOpen,
    allowedRoles: ['admin'],
  },
  {
    label: 'User',
    icon: faChartLine,
    allowedRoles: ['user', 'admin'],
    icon: faUser,
    subMenuItems: [
      {
        label: 'List',
        path: 'user-list',
        allowedRoles: ['user', 'admin'],
        icon: faUser,
      },
      {
        label: 'User Edit',
        path: 'user-edit',
        allowedRoles: ['user', 'admin'],
        icon: faUser,
      },
    ],
  },
  // {
  //   label: 'Users',
  //   path: 'users',
  //   icon: faUser,
  //   allowedRoles: ['user', 'admin'],
  // },
];

const NavItem = ({ navItem }) => {
  const location = useLocation();
  const isSubMenuRoute =
    navItem.subMenuItems &&
    navItem.subMenuItems.find(menu => `/${menu.path}` === location.pathname);
  const isCurrentRoute = location.pathname === `/${navItem.path}`;
  const [showSubMenu, setShowSubMenu] = useState(false);
  const classes = classNames({
    'px-2 sm:px-6 justify-center sm:justify-start py-3 rounded-full flex': true,
    'text-gray-600 hover:text-blue-500 transform hover:translate-x-1 transition ease-in-out duration-100':
      !isCurrentRoute && !isSubMenuRoute,
    'bg-gradient text-gray-100 shadow-lg': isCurrentRoute || isSubMenuRoute,
  });

  const subMenuClasses = classNames({
    'ml-6 items-center': true,
    hidden: !showSubMenu,
  });

  const subMenuItemClasses = path => {
    const isSelected = location.pathname === `/${path}`;
    return classNames({
      'px-2 sm:px-6 justify-center sm:justify-start py-3 rounded-full flex': true,
      'text-gray-600 hover:text-blue-500': !isSelected,
      'bg-gradient text-gray-100 shadow-lg': isSelected,
    });
  };

  return (
    <div>
      {navItem.subMenuItems && navItem.subMenuItems.length ? (
        <div>
          <div className={classes} onClick={() => setShowSubMenu(!showSubMenu)}>
            <div className="flex items-center">
              <div className="mr-0 sm:mr-4">
                <FontAwesomeIcon icon={navItem.icon} />
              </div>
              <span className="hidden sm:block">{navItem.label}</span>
              <span className="ml-2 mr-0 sm:mr-4" id="arrow">
                <a href="#">
                  <FontAwesomeIcon
                    icon={showSubMenu ? faArrowUp : faArrowDown}
                  />
                </a>
              </span>
            </div>
          </div>
          <div className={subMenuClasses}>
            {navItem.subMenuItems.map((subMenuItem, i) => (
              <Link
                to={subMenuItem.path}
                key={i}
                className={subMenuItemClasses(subMenuItem.path)}
              >
                {subMenuItem.label}
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <Link to={navItem.path} className={classes}>
          <div className="flex items-center">
            <div className="mr-0 sm:mr-4">
              <FontAwesomeIcon icon={navItem.icon} />
            </div>
            <span className="hidden sm:block">{navItem.label}</span>
          </div>
        </Link>
      )}
    </div>
  );
};

const NavItemContainer = ({ children }) => <div>{children}</div>;

const Sidebar = () => {
  const auth = useContext(AuthContext);
  const { role } = auth.authState.userInfo;
  return (
    <section className="h-screen">
      <div className="m-auto">
        <img
          style={{ width: 168, height: 55 }}
          src={logo}
          rel="logo"
          alt="Logo"
        />
      </div>
      <div className="mt-20">
        {navItems.map((navItem, i) => (
          <NavItemContainer key={i}>
            {navItem.allowedRoles.includes(role) && (
              <NavItem navItem={navItem} />
            )}
          </NavItemContainer>
        ))}
      </div>
    </section>
  );
};

export default Sidebar;
